import styled from 'styled-components';
import {
  COLOR_BLUE_007,
  COLOR_BLUE_050,
  COLOR_BLUE,
} from '@common/assets/styles/colors';

export default styled.textarea`
  width: 100%;
  height: auto;

  color: ${COLOR_BLUE};
  background-color: ${COLOR_BLUE_007};

  border-width: 0;
  border-radius: 8px;

  padding: 12px;

  min-height: 30px;
  max-height: 200px;
  resize: none;
  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${COLOR_BLUE_050};
  }

  font-size: 14px;
  line-height: 14px;
`;
